var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"move-lists"},[_c('div',{},[_c('moveList',{staticClass:"d11",attrs:{"onMove":_vm.getMoveFunc(1,2),"items":_vm.assigned,"title":_vm.listAtitle,"noFilter":_vm.noFilter}}),_vm._v(" "),_c('moveList',{attrs:{"onMove":_vm.getMoveFunc(2,1),"items":_vm.notAssignedList,"isLast":true,"title":_vm.listBtitle,"noFilter":_vm.noFilter}})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-316f400a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/movelists/MoveLists.vue
// module id = 731
// module chunks = 1